import resultados from './resultados'
import usuarios from './usuarios'
import materialApoyo from './materialapoyo'
import asesorias from './asesorias'

// ** Merge & Export
export default [...resultados]
